import React from 'react';
export function Accessories() {
  return <div className="bg-white min-h-screen pt-32 pb-20 px-6" data-id="element-286">
      <div className="max-w-[1800px] mx-auto" data-id="element-287">
        <header className="mb-20 text-center" data-id="element-288">
          <span className="text-[10px] font-display uppercase tracking-[0.5em] mb-4 block text-black/40" data-id="element-289">
            The Finishing Touch
          </span>
          <h1 className="text-4xl md:text-6xl font-display font-bold tracking-[0.2em] uppercase mb-6" data-id="element-290">
            Accessories
          </h1>
          <p className="max-w-xl mx-auto text-sm font-light tracking-widest text-black/60 leading-relaxed uppercase" data-id="element-291">
            Jewelry, headwraps, and footwear to complete the Djili look.
          </p>
        </header>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-292">
          {['https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?auto=format&fit=crop&q=80&w=600', 'https://images.unsplash.com/photo-1549298916-b41d501d3772?auto=format&fit=crop&q=80&w=600', 'https://images.unsplash.com/photo-1611591437281-460bfbe1220a?auto=format&fit=crop&q=80&w=600', 'https://images.unsplash.com/photo-1602173574767-37ac01994b2a?auto=format&fit=crop&q=80&w=600'].map((img, i) => <div key={i} className="aspect-square bg-grey-divider overflow-hidden group cursor-pointer" data-id="element-293">
              <img src={img} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" alt="Accessory" data-id="element-294" />
            </div>)}
        </div>
      </div>
    </div>;
}